export const dashboard = {
  title: "Painel",
  filters: {
    accommodation: "Acomodação",
    allAccommodations: "Todas as acomodações",
    period: "Período",
    periodOptions: {
      today: "Hoje",
      week: "Semana",
      month: "Mês",
      year: "Ano",
    },
  },
  actions: {
    createBooking: "Criar reserva",
  },
  pendingWidget: {
    title: "Ações pendentes",
    subtitle: "Pagamentos, solicitações e quartos a atribuir.",
    oneRequest: "solicitação",
    manyRequests: "solicitações",
    onePayment: "pagamento",
    manyPayments: "pagamentos",
    oneUnassigned: "a atribuir",
    manyUnassigned: "a atribuir",
    loading: "Carregando ações pendentes...",
    emptyTitle: "Nenhuma ação pendente",
    emptyText: "Quando chegar uma nova solicitação ou uma reserva ficar aguardando pagamento, ela aparecerá aqui.",
    noName: "Sem nome",
    accommodation: "Acomodação",
    guest: "hóspede",
    guests: "hóspedes",
    requestShort: "Solicitação",
    pendingPaymentShort: "Aguardando pagamento",
    unassignedShort: "Atribuir quarto",
    approve: "Aprovar",
    reject: "Recusar",
    viewAll: "Ver todas as reservas",
    modalApproveTitle: "Aprovar solicitação",
    modalRejectTitle: "Recusar solicitação",
    modalApproveText1: "Você está prestes a aprovar a solicitação de",
    modalApproveText2: "Se esta reserva usar pagamento online, ela passará para aguardando pagamento.",
    modalRejectText1: "Você está prestes a recusar a solicitação de",
    modalRejectText2: "Você pode informar um motivo para enviá-lo ao hóspede por e-mail.",
    rejectReasonLabel: "Motivo da recusa",
    rejectReasonPlaceholder: "Selecione um motivo",
    reasonDatesUnavailable: "As datas não estão mais disponíveis",
    reasonPriceUnavailable: "A tarifa não está mais disponível",
    reasonMinimumStay: "Não atende à estadia mínima",
    reasonHouseRules: "Não atende às regras da acomodação",
    reasonOther: "Outro motivo",
    rejectReasonOtherPlaceholder: "Escreva o motivo da recusa",
    rejectReasonRequired: "Você precisa selecionar um motivo da recusa.",
    rejectReasonOtherRequired: "Você precisa escrever o motivo da recusa.",
    cancel: "Cancelar",
    confirmApprove: "Sim, aprovar",
    confirmReject: "Sim, recusar",
    statusUpdatedSuccess: "Status atualizado com sucesso.",
    statusUpdatedError: "Não foi possível atualizar o status."
  },

  stats: {
    totalReservations: {
      today:   "Reservas hoje",
      week:    "Reservas esta semana",
      month:   "Reservas este mês",
      year:    "Reservas este ano",
      default: "Total de reservas",
    },
    checkIns: {
      today:   "Check-ins hoje",
      week:    "Check-ins esta semana",
      month:   "Check-ins este mês",
      year:    "Check-ins este ano",
      default: "Check-ins",
    },
    occupancy: {
      today:   "Ocupação hoje",
      week:    "Ocupação semanal",
      month:   "Ocupação mensal",
      year:    "Ocupação anual",
      default: "Ocupação",
    },
    revenue: {
      today:   "Receita de hoje",
      week:    "Receita semanal",
      month:   "Receita mensal",
      year:    "Receita anual",
      default: "Receita",
    },
  },
  section3: {
    title: "Próximas reservas",
    subtitle: "Lista das próximas chegadas da sua acomodação",
    timeFilters: {
      upcoming: "Próximas",
      thisWeek: "Esta semana",
      today: "Hoje",
      tomorrow: "Amanhã",
      month: "Mês",
    },
    table: {
      headers: {
        responsible: "Responsável",
        checkInDate: "Data do check-in",
        entry: "Entrada",
        guests: "Hóspedes",
        status: "Status",
      },
    },
    empty: {
      today: {
        title: "Você não tem chegadas para hoje",
        description:
          "Quando você tiver uma nova chegada agendada para hoje, ela aparecerá aqui com os detalhes importantes.",
      },
      default: {
        title: "Você não tem próximas chegadas",
        description:
          "Quando você tiver novas chegadas agendadas, elas aparecerão aqui com os detalhes importantes.",
      },
    },
    loading: "Carregando reservas...",
    statuses: {
      inProgress: "Em andamento",
      complete: "Completo",
      pending: "Pendente",
      approved: "Aprovado",
    },
    actions: {
      replyOnWhatsApp: "Responder no WhatsApp",
    },
    nights: "{count} noite | {count} noites",
  },
  section4: {
    title: "Detalhamento da receita",
    total: "Receita total",
    emptyChart: "Nenhum dado disponível",
    noData: "Não há dados de receita para exibir",
  },
  section5: {
    title: "Receita total",
    datasetLabel: "Receita",
    filters: {
      weekly: "Semanal",
      monthly: "Mensal",
      "6m": "6 meses",
      "12m": "12 meses",
      "24m": "24 meses",
    },
    loading: "Carregando dados...",
    errors: {
      load: "Erro ao carregar os dados",
      connection: "Erro de conexão",
    },
  },
  design: {
    title: `Design do painel`,
    reorder: `Reordenar`,
    active: `Ativo`,
    theme: `Tema`,
    color: `Colorido`,
    green: `Verde`,
    system: `Sistema`,
    white: `Branco`,
    sidebar: `Barra lateral`,
    black: `Preto`,
  },
  earlyCheckin: {
    earlyShort: `Antes`,
    arrivesShort: `Chega`,
    arrivalAt: `Às {time}`,
    requested: `Check-in antecipado solicitado`,
    arrivalRequested: `Horário de chegada solicitado`,
  },
};
